export function extractLocalPhoneDigits(phoneRaw: string): string {
  return phoneRaw.replace(/^\+\d+\s*/, '').replace(/\D/g, '').slice(0, 10)
}

/** Matches server-side normalizePhoneE164 behavior for Persona inquiry phones. */
export function buildPersonaPhoneE164(phoneRaw: string): string {
  const trimmed = phoneRaw.trim()
  const digits = trimmed.replace(/\D/g, '')
  if (digits.length === 10) {
    return `+1${digits}`
  }
  if (digits.length === 11 && digits.startsWith('1')) {
    return `+${digits}`
  }
  if (trimmed.startsWith('+') && digits.length >= 10) {
    return `+${digits}`
  }
  return trimmed
}

export function phoneRawToE164(phoneRaw: string): string | null {
  const normalized = buildPersonaPhoneE164(phoneRaw)
  if (/^\+\d{11,15}$/.test(normalized)) {
    return normalized
  }
  return null
}

export function formatPhoneForBasicDisplay(raw: string): string {
  const digits = raw.replace(/\D/g, '')
  const localDigits =
    digits.length === 11 && digits.startsWith('1')
      ? digits.slice(1)
      : digits.length >= 10
        ? digits.slice(-10)
        : digits

  if (localDigits.length === 10) {
    return `+1 (${localDigits.slice(0, 3)}) ${localDigits.slice(3, 6)}-${localDigits.slice(6)}`
  }

  const trimmed = raw.trim()
  return trimmed || '+1 '
}
